import React, { Component } from 'react'
import $ from 'jquery'

import TextInput from '../../../textInput'
import { urlFormat, notEmpty, isValid, justNumber } from '../../../validations'
import moment from 'moment';
import { createSlug } from '../../../utils'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import FileDropZone from '../../fileDropZone'
import { configs } from '../../../helpers/constants'
import { post, postFormData, get } from '../../../utils/networking'
import CheckBoxes from '../checkboxes'
import TimePicker from 'rc-time-picker'
import '../../../../node_modules/rc-time-picker/assets/index.css'
import * as Notify from '../../../notification'

const validationData = {
    photo: [notEmpty]
}

export default class GeneralSetting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            serviceSummary: "",
            serviceDescription: "",
            serviceAttachment: "gdfsf",
            serviceIds: [
                0
            ],
            featureIds: [
                0
            ],
            hoursofOperation: {
                monday: "",
                tuesday: "",
                wednesday: "",
                thursday: "",
                friday: "",
                saturday: "",
                sunday: ""
            },
            options: [],
            features: [],
            isLoaded: 0,
            isMore: false
        }
    }



    componentDidMount() {
        get("spa/get", "partner",
            result => {
                this.setState({
                    serviceSummary: result.serviceSummary,
                    serviceDescription: result.serviceDescription,
                    serviceAttachment: result.serviceAttachment,
                    serviceIds: result.services,
                    featureIds: result.features,
                    hoursofOperation: result.hoursofOperation,
                    isLoaded: this.state.isLoaded + 1
                })
            })

        get("/spa/getOptions", "partner",
            result => {
                this.setState({
                    options: result.services,
                    features: result.features,
                    isLoaded: this.state.isLoaded + 1
                })
            })
    }

    onSummaryChange(e) {
        document.getElementById("summary_validation").textContent = "";
        this.setState({
            serviceSummary: e.target.value
        })
    }
    onDescriptionChange(e) {
        document.getElementById("description_validation").textContent = "";
        this.setState({
            serviceDescription: e.target.value
        })
    }

    onSelectService(optionId) {
        let newServiceIds = this.state.serviceIds;
        newServiceIds.push(optionId);
        this.setState({
            serviceIds: newServiceIds
        })
    }

    onRemoveService(optionId) {
        let newServiceIds = this.state.serviceIds.filter(x => x != optionId);
        this.setState({
            serviceIds: newServiceIds
        })
    }

    onSelectFeature(optionId) {
        let newFeatureID = this.state.featureIds;
        newFeatureID.push(optionId);
        this.setState({
            featureIds: newFeatureID
        })
    }

    onRemoveFeature(optionId) {
        let newFeatureIds = this.state.featureIds.filter(x => x != optionId);
        this.setState({
            featureIds: newFeatureIds
        })
    }

    onDateChange(key, value) {
        var state = this.state
        var props = key.split(".")

        switch (props.length) {
            case 2:
                state[props[0]][props[1]] = value
                break;
            case 3:
                state[props[0]][props[1]][props[2]] = value
                break;
            default:
                state[props[0]] = value
                break;
        }

        this.setState({ ...state })
    }
    handleUpdate() {
        Notify.hide();
        let param = {
            serviceSummary: this.state.serviceSummary,
            serviceDescription: this.state.serviceDescription,
            serviceAttachment: this.state.serviceAttachment,
            serviceIds: this.state.serviceIds,
            featureIds: this.state.featureIds,
            hoursofOperation: this.state.hoursofOperation
        }
        post("spa/updateServices", param, "partner", result => {
            Notify.show($("#services_save"), "Update success", "success", "0");
        }, errors => {
            Notify.show($("#services_save"), errors.errors[0], "fail", "0");
        })
    }

    render() {
        let {
            serviceSummary,
            serviceDescription,
            serviceAttachment,
            serviceIds,
            featureIds,
            hoursofOperation,
            options,
            features,
            isLoaded,
            isMore
        } = this.state

        const hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        const minutes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60]

        return (
            (isLoaded > 1) ? <div className="service_setting">
                <div className="header">
                    <p>Services setting</p>
                </div>
                <div className="detail">
                    <div className="form-group info">
                        <label>Summary</label>
                        <textarea value={serviceSummary} className="summary" onChange={(value) => this.onSummaryChange(value)}></textarea>
                        <p id="summary_validation" className="text-danger"></p>
                    </div>
                    <div className="form-group info">
                        <label>Description</label>
                        <textarea value={serviceDescription} className="description" onChange={(value) => this.onDescriptionChange(value)}></textarea>
                        <p id="description_validation" className="text-danger"></p>
                    </div>
                    {/* <div className="form-group info services">
                        <label
                            onClick={() => {
                                $(".services-group").toggleClass("show");
                                if (isMore)
                                    $("html, body").animate({ scrollTop: 600 }, 400);
                                this.setState({
                                    isMore: !this.state.isMore
                                });
                            }}
                        >Services</label>
                        <div className="services-group">
                            {
                                ((!isMore) ? options.filter((item, index) => index < 2) : options).map((itemType, i) =>
                                    <div className="optionType" key={i}>
                                        <div className="optionType-tile">
                                            <span>{itemType.name}</span>
                                        </div>
                                        <div className="optionType-detail">
                                            <CheckBoxes
                                                className="service-checkboxes"
                                                options={itemType.services}
                                                selectOptions={serviceIds}
                                                onSelect={this.onSelectService.bind(this)}
                                                onRemove={this.onRemoveService.bind(this)}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <span className="load_more"
                            onClick={() => {
                                $(".services-group").toggleClass("show");
                                if (isMore)
                                    $("html, body").animate({ scrollTop: 700 }, 400);
                                this.setState({
                                    isMore: !this.state.isMore
                                });
                            }}
                        ><i className="services_expand_bt">{(isMore) ? "Less" : "More"}</i></span>
                    </div> */}
                    <div className="form-group info">
                        <label>Features</label>
                        <CheckBoxes
                            className="features-checkboxes"
                            options={features}
                            selectOptions={featureIds}
                            onSelect={this.onSelectFeature.bind(this)}
                            onRemove={this.onRemoveFeature.bind(this)}
                        />
                    </div>
                    <div className="form-group info hours-of-operation">
                        <label>Hours of Operation</label>
                        <div className="hours-detail">
                            <TextInput
                                name="monday"
                                label="Monday"
                                value={hoursofOperation.monday}
                                showLabel={true}
                                readOnly={true}
                                onChange={(value) => this.onDateChange("hoursofOperation.monday", value)}
                            />
                            <TextInput
                                name="tuesday"
                                label="Tuesday"
                                value={hoursofOperation.tuesday}
                                showLabel={true}
                                readOnly={true}
                                onChange={(value) => this.onDateChange("hoursofOperation.tuesday", value)}
                            />
                            <TextInput
                                name="wednesday"
                                label="Wednesday"
                                value={hoursofOperation.wednesday}
                                showLabel={true}
                                readOnly={true}
                                onChange={(value) => this.onDateChange("hoursofOperation.wednesday", value)}
                            />
                            <TextInput
                                name="thursday"
                                label="Thursday"
                                value={hoursofOperation.thursday}
                                showLabel={true}
                                readOnly={true}
                                onChange={(value) => this.onDateChange("hoursofOperation.thursday", value)}
                            />
                            <TextInput
                                name="friday"
                                label="Friday"
                                value={hoursofOperation.friday}
                                showLabel={true}
                                readOnly={true}
                                onChange={(value) => this.onDateChange("hoursofOperation.friday", value)}
                            />
                            <TextInput
                                name="saturday"
                                label="Saturday"
                                value={hoursofOperation.saturday}
                                showLabel={true}
                                readOnly={true}
                                onChange={(value) => this.onDateChange("hoursofOperation.saturday", value)}
                            />
                            <TextInput
                                name="sunday"
                                label="Sunday"
                                value={hoursofOperation.sunday}
                                showLabel={true}
                                readOnly={true}
                                onChange={(value) => this.onDateChange("hoursofOperation.sunday", value)}
                            />
                        </div>
                    </div>
                    <div className="form-group info submit">
                        <button className="services_save" id="services_save" onClick={this.handleUpdate.bind(this)}>Save</button>
                    </div>
                </div>
            </div> : <div>
                    <div className="spinner">
                        <div className="rect1"></div>
                        <div className="rect2"></div>
                        <div className="rect3"></div>
                        <div className="rect4"></div>
                        <div className="rect5"></div>
                    </div>
                </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/partner/service/index.js